import React, { useEffect, useState } from "react";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import { convertThenFormat, formatDateTime } from "../common-data/Converts";
import { formatWTFString } from "../common-data/Conversions";
import { getStatusLabel } from "./ExpenseRequestLists";
import CommonStatCard from "../pt/pt-flow-new/CommonStatCard";
import { useSelector } from "react-redux";
import PettyCashMobile from "./PettyCashMobile";
import PettyCashStats from "./expense-management/PettyCashStats";
import { CheckCircleIcon, CrossCircleIcon } from "../../images/icons/icons";

const PettyCashLists = ({
  userInfoData,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  setModValues,
  isExpenseManager,
  allPettyCashStats,
  allPettyCashStatsLoading,
  onCardClick,
  selectedStatus,
}) => {
  const expenseManagerRole =
    (isExpenseManager && isExpenseManager?.role_type) || null;

  const { expenseRequestsLoading, expenseRequests } = useSelector(
    (state) => state.hygiene
  );

  const iniPTDatas = {
    pagination: [],
    allData: [],
    allStats: {},
  };

  const [allDatas, setAllDatas] = useState(iniPTDatas);

  useEffect(() => {
    if (expenseRequests?.status && expenseRequests?.data?.length > 0) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: expenseRequests.data,
        pagination:
          expenseRequests?.pagination?.length > 0
            ? expenseRequests.pagination
            : [],
        allStats: expenseRequests?.stats || {},
      }));
    } else {
      setAllDatas(iniPTDatas);
    }
  }, [expenseRequests]);

  const tbColumns = [
    {
      dataField: "status",
      text: "Status",
      formatter: (_, row) => {
        const planStatus = row?.status?.replace(/ /g, "_")?.toLowerCase();

        return (
          <span className="tb-data icon">
            {planStatus === "approved_paid" ? (
              <CheckCircleIcon />
            ) : planStatus === "approved_notpaid" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-clock-history"
                viewBox="0 0 16 16"
                style={{ color: "#006BFF" }}
              >
                <path d="M8.515 1.019A7 7 0 0 0 8 1V0a8 8 0 0 1 .589.022zm2.004.45a7 7 0 0 0-.985-.299l.219-.976q.576.129 1.126.342zm1.37.71a7 7 0 0 0-.439-.27l.493-.87a8 8 0 0 1 .979.654l-.615.789a7 7 0 0 0-.418-.302zm1.834 1.79a7 7 0 0 0-.653-.796l.724-.69q.406.429.747.91zm.744 1.352a7 7 0 0 0-.214-.468l.893-.45a8 8 0 0 1 .45 1.088l-.95.313a7 7 0 0 0-.179-.483m.53 2.507a7 7 0 0 0-.1-1.025l.985-.17q.1.58.116 1.17zm-.131 1.538q.05-.254.081-.51l.993.123a8 8 0 0 1-.23 1.155l-.964-.267q.069-.247.12-.501m-.952 2.379q.276-.436.486-.908l.914.405q-.24.54-.555 1.038zm-.964 1.205q.183-.183.35-.378l.758.653a8 8 0 0 1-.401.432z" />
                <path d="M8 1a7 7 0 1 0 4.95 11.95l.707.707A8.001 8.001 0 1 1 8 0z" />
                <path d="M7.5 3a.5.5 0 0 1 .5.5v5.21l3.248 1.856a.5.5 0 0 1-.496.868l-3.5-2A.5.5 0 0 1 7 9V3.5a.5.5 0 0 1 .5-.5" />
              </svg>
            ) : planStatus === "pending" ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-hourglass-split"
                viewBox="0 0 16 16"
                style={{ color: "#d9610b" }}
              >
                <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z" />
              </svg>
            ) : (
              <CrossCircleIcon />
            )}
            <br />
            {getStatusLabel(row?.status || "-")}
          </span>
        );
      },
    },
    {
      dataField: "requested_amount",
      text: "Requested Amount",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth120">
            <b>₹{convertThenFormat(row?.requested_amount || 0)}</b>
          </span>
        );
      },
    },

    {
      dataField: "requested_by_details",
      text: "Requested By",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth180" style={{ fontSize: "14px" }}>
            <b>{row?.requested_by_name || "NA"}</b>
            <br />
            <small className="underline">
              {row?.requested_by_account_type && (
                <>
                  {row.requested_by_account_type?.replace(/_/g, " ")}
                  <br />
                </>
              )}
              {row?.requested_by_mobile && (
                <>
                  {row.requested_by_mobile}
                  <br />
                </>
              )}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "expense_type",
      text: "Expense Type",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            <b
              className="underline"
              style={{
                backgroundColor: "#e6f3ff",
                padding: "4px 8px",
                borderRadius: "4px",
                color: "#0066cc",
              }}
            >
              {formatWTFString(row?.expense_type || "")}
            </b>
            {row?.gym_name ? (
              <>
                <br />
                {row.gym_name}
              </>
            ) : null}
          </span>
        );
      },
    },
    {
      dataField: "date_added",
      text: "Date Added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTime(row.date_added) : "-"}
          </span>
        );
      },
    },
    {
      dataField: "payment_method",
      text: "Payment Method",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            <b className="underline">{row?.payment_method || "NA"}</b>

            {row?.payment_method === "bank" && (
              <small>
                <br />
                account no: <b>{row?.account_number || ""}</b>
                <br />
                IFSC: <b>{row?.ifsc_code || ""}</b>
              </small>
            )}

            {row?.payment_method === "upi" && (
              <small
                style={{
                  textTransform: "initial",
                }}
              >
                <br />
                {row?.upi_id || ""}
              </small>
            )}
          </span>
        );
      },
    },
    {
      dataField: "approval_manager",
      text: "Approval Manager",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">
            <b>{row?.approval_manager_name || "NA"}</b>
            <br />
            <small className="underline">
              {row?.approval_manager_email && (
                <>
                  {row.approval_manager_email}
                  <br />
                </>
              )}
              {row?.approval_manager_mobile && (
                <>
                  {row.approval_manager_mobile}
                  <br />
                </>
              )}
            </small>
          </span>
        );
      },
    },
    // {
    //   dataField: "expense_category",
    //   text: "Expense Category",
    //   formatter: (_, row) => {
    //     return (
    //       <span className="tb-data">{row?.expense_category_name || "NA"}</span>
    //     );
    //   },
    // },
    // {
    //   dataField: "payment_method_img",
    //   text: "Payment Method Image",
    //   formatter: (_, row) => {
    //     return (
    //       <span
    //         className="tb-data icon cursor-pointer"
    //         onClick={() =>
    //           row?.payment_method_img &&
    //           setModValues((prevs) => ({
    //             ...prevs,
    //             isModOpen: true,
    //             cardName: "image",
    //             image: row?.payment_method_img,
    //           }))
    //         }
    //       >
    //         {row?.payment_method_img ? (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-yelp"
    //             viewBox="0 0 16 16"
    //           >
    //             <path d="m4.188 10.095.736-.17.073-.02A.813.813 0 0 0 5.45 8.65a1 1 0 0 0-.3-.258 3 3 0 0 0-.428-.198l-.808-.295a76 76 0 0 0-1.364-.493C2.253 7.3 2 7.208 1.783 7.14c-.041-.013-.087-.025-.124-.038a2.1 2.1 0 0 0-.606-.116.72.72 0 0 0-.572.245 2 2 0 0 0-.105.132 1.6 1.6 0 0 0-.155.309c-.15.443-.225.908-.22 1.376.002.423.013.966.246 1.334a.8.8 0 0 0 .22.24c.166.114.333.129.507.141.26.019.513-.045.764-.103l2.447-.566zm8.219-3.911a4.2 4.2 0 0 0-.8-1.14 1.6 1.6 0 0 0-.275-.21 2 2 0 0 0-.15-.073.72.72 0 0 0-.621.031c-.142.07-.294.182-.496.37-.028.028-.063.06-.094.089-.167.156-.353.35-.574.575q-.51.516-1.01 1.042l-.598.62a3 3 0 0 0-.298.365 1 1 0 0 0-.157.364.8.8 0 0 0 .007.301q0 .007.003.013a.81.81 0 0 0 .945.616l.074-.014 3.185-.736c.251-.058.506-.112.732-.242.151-.088.295-.175.394-.35a.8.8 0 0 0 .093-.313c.05-.434-.178-.927-.36-1.308M6.706 7.523c.23-.29.23-.722.25-1.075.07-1.181.143-2.362.201-3.543.022-.448.07-.89.044-1.34-.022-.372-.025-.799-.26-1.104C6.528-.077 5.644-.033 5.04.05q-.278.038-.553.104a8 8 0 0 0-.543.149c-.58.19-1.393.537-1.53 1.204-.078.377.106.763.249 1.107.173.417.41.792.625 1.185.57 1.036 1.15 2.066 1.728 3.097.172.308.36.697.695.857q.033.015.068.025c.15.057.313.068.469.032l.028-.007a.8.8 0 0 0 .377-.226zm-.276 3.161a.74.74 0 0 0-.923-.234 1 1 0 0 0-.145.09 2 2 0 0 0-.346.354c-.026.033-.05.077-.08.104l-.512.705q-.435.591-.861 1.193c-.185.26-.346.479-.472.673l-.072.11c-.152.235-.238.406-.282.559a.7.7 0 0 0-.03.314c.013.11.05.217.108.312q.046.07.1.138a1.6 1.6 0 0 0 .257.237 4.5 4.5 0 0 0 2.196.76 1.6 1.6 0 0 0 .349-.027 2 2 0 0 0 .163-.048.8.8 0 0 0 .278-.178.7.7 0 0 0 .17-.266c.059-.147.098-.335.123-.613l.012-.13c.02-.231.03-.502.045-.821q.037-.735.06-1.469l.033-.87a2.1 2.1 0 0 0-.055-.623 1 1 0 0 0-.117-.27Zm5.783 1.362a2.2 2.2 0 0 0-.498-.378l-.112-.067c-.199-.12-.438-.246-.719-.398q-.644-.353-1.295-.695l-.767-.407c-.04-.012-.08-.04-.118-.059a2 2 0 0 0-.466-.166 1 1 0 0 0-.17-.018.74.74 0 0 0-.725.616 1 1 0 0 0 .01.293c.038.204.13.406.224.583l.41.768q.341.65.696 1.294c.152.28.28.52.398.719q.036.057.068.112c.145.239.261.39.379.497a.73.73 0 0 0 .596.201 2 2 0 0 0 .168-.029 1.6 1.6 0 0 0 .325-.129 4 4 0 0 0 .855-.64c.306-.3.577-.63.788-1.006q.045-.08.076-.165a2 2 0 0 0 .051-.161q.019-.083.029-.168a.8.8 0 0 0-.038-.327.7.7 0 0 0-.165-.27" />
    //           </svg>
    //         ) : (
    //           <svg
    //             xmlns="http://www.w3.org/2000/svg"
    //             width="16"
    //             height="16"
    //             fill="currentColor"
    //             className="bi bi-x-circle-fill"
    //             viewBox="0 0 16 16"
    //             style={{ color: "#E41815" }}
    //           >
    //             <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
    //           </svg>
    //         )}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "details",
      text: "View Details",
      formatter: (_, row) => {
        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              className="actionBtn icon"
              onClick={() => {
                setModValues((prevs) => ({
                  ...prevs,
                  isModOpen: true,
                  cardName: "view_details",
                  rowData: row,
                }));
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="#000"
                className="bi bi-eye-fill"
                viewBox="0 0 16 16"
              >
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8m8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
              </svg>
            </button>
          </div>
        );
      },
    },
    {
      dataField: "requested_img",
      text: "Print Bill",
      formatter: (_, row) => {
        const handlePrintImage = () => {
          if (row?.requested_img) {
            // Create a new window for printing
            const printWindow = window.open("", "_blank");

            // Create the HTML content for printing
            const printContent = `
              <html>
                <head>
                  <title>Print Bill</title>
                  <style>
                    body {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      margin: 0;
                      padding: 20px;
                    }
                    img {
                      max-width: 100%;
                      height: auto;
                    }
                  </style>
                </head>
                <body>
                  <img src="${row.requested_img}" alt="Bill Image" />
                </body>
              </html>
            `;

            // Write the content to the new window
            printWindow.document.write(printContent);
            printWindow.document.close();

            // Wait for the image to load before printing
            printWindow.onload = () => {
              printWindow.print();
              // Close the window after printing
              printWindow.onafterprint = () => {
                printWindow.close();
              };
            };
          }
        };

        return (
          <div
            className="actionButtonContainer"
            style={{
              flexDirection: "column",
              justifyContent: "center",
              gap: "0",
            }}
          >
            <button
              type="button"
              className="actionBtn icon"
              onClick={handlePrintImage}
              disabled={!row?.requested_img}
              style={{
                cursor: row?.requested_img ? "pointer" : "not-allowed",
                opacity: row?.requested_img ? 1 : 0.5,
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-cloud-arrow-down-fill"
                viewBox="0 0 16 16"
              >
                <path d="M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2m2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708" />
              </svg>
            </button>
          </div>
        );
      },
    },
    {
      dataField: "status",
      text: userInfoData?.account_type === "cluster_manager" ? "Action" : "",
      formatter: (_, row) => {
        const planStatus = row?.status?.replace(/ /g, "_")?.toLowerCase();
        const isSameAccount =
          (userInfoData?.uid || userInfoData?.user_id) === row?.requested_by;
        const isEditDisable = !isSameAccount || planStatus !== "pending";

        return (
          <>
            {isSameAccount &&
            userInfoData?.account_type === "cluster_manager" ? (
              <button
                className="actionBtn icon edit"
                disabled={isEditDisable}
                style={{
                  cursor: !isEditDisable ? "pointer" : "not-allowed",
                }}
                onClick={() =>
                  setModValues((prevs) => ({
                    ...prevs,
                    isModOpen: true,
                    cardName: "edit",
                    rowData: row,
                  }))
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-pencil-fill"
                  viewBox="0 0 16 16"
                  style={{
                    color: isEditDisable ? "gray" : "#CD0909",
                  }}
                >
                  <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
                </svg>
              </button>
            ) : null}
          </>
        );
      },
    },
  ];

  return (
    <>
      {allPettyCashStatsLoading ? (
        <ReactVortoxSpinner />
      ) : (
        <PettyCashStats
          allStats={allPettyCashStats?.data}
          onCardClick={onCardClick}
          selectedStatus={selectedStatus}
        />
      )}

      <div className="fullWidthFlexCenter overflowAuto separatedTable no-border-table mt30 hideMobile">
        {expenseRequestsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PaymentLinkTable
            tableData={allDatas.allData}
            tableColumns={tbColumns}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            isFirstColSticky={true}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        )}
      </div>

      <div className="lead-logs-card-container only-mobile">
        {expenseRequestsLoading ? (
          <ReactVortoxSpinner />
        ) : (
          <PettyCashMobile
            tableData={allDatas.allData}
            tablePagination={allDatas.pagination}
            isPage={isPage}
            setIsPage={(value) => setIsPage(value)}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            userInfoData={userInfoData}
            setModValues={setModValues}
          />
        )}
      </div>
    </>
  );
};

export default PettyCashLists;
